import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a379b54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "main-header" }
const _hoisted_3 = { class: "popup-menu" }
const _hoisted_4 = { class: "main-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainHeaderSortMenu = _resolveComponent("MainHeaderSortMenu")!
  const _component_AlphabetMenu = _resolveComponent("AlphabetMenu")!
  const _component_DayMenuButtons = _resolveComponent("DayMenuButtons")!
  const _component_NoResults = _resolveComponent("NoResults")!
  const _component_GuestCard = _resolveComponent("GuestCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_MainHeader, {
        guestTypes: _ctx.guestType,
        programs: _ctx.programs,
        route: { name: 'schedule', type: 'type', id: 'id' },
        text: 
          this.$store.state.language === 'fr' ? 'Programmation' : 'Schedule'
        ,
        stateMenuFilter: this.sortedDays()[0],
        showSelect: true
      }, null, 8, ["guestTypes", "programs", "text", "stateMenuFilter"]),
      _createVNode(_component_MainHeaderSortMenu, {
        category: _ctx.categorySchedule,
        selectItems: _ctx.tags,
        route: "main"
      }, null, 8, ["category", "selectItems"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _withDirectives(_createVNode(_component_AlphabetMenu, { class: "show" }, null, 512), [
        [_vShow, _ctx.$store.state.activeDayMenu.menu === 1]
      ]),
      _withDirectives(_createVNode(_component_DayMenuButtons, {
        text: _ctx.sortedDays(),
        class: "show"
      }, null, 8, ["text"]), [
        [_vShow, _ctx.$store.state.activeDayMenu.menu === 2]
      ])
    ]),
    _withDirectives(_createVNode(_component_NoResults, null, null, 512), [
      [_vShow, _ctx.searchFilter(this.store.state.searchResults, 'main').length == 0]
    ]),
    _createElementVNode("main", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchFilter(this.store.state.searchResults, 'main'), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id
        }, [
          _createVNode(_component_GuestCard, {
            id: item.id,
            name: item.name,
            title: item.title,
            place: item.place?.place ? item.place?.place : item.place,
            image: item.image,
            date: item.day,
            hour: item.hour,
            onClick: ($event: any) => (_ctx.routeChoice(item))
          }, null, 8, ["id", "name", "title", "place", "image", "date", "hour", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}